export const TokenKey = "SRM_Purchasing_Token";
export const UserInfoKey = "SRM_Purchasing_UserInfo";
